
export default class NumSearchChange {
  constructor () {
  	this.res= /([^0-9,])|([~!@\#$%^&*\()\-=+_'])/g;
  }

  /* check ( elem ) {
		let num;
		if( elem.value.search(this.res) != -1 ){
			alert('숫자만 입력 가능합니다.');
			elem.value= elem.value.replace(this.res,"");
			num= parseInt(elem.value);
			elem.focus();
		} else {
			num= parseInt(elem.value.replace(/,/g,""))
		  if( elem.value ) elem.value= num.toLocaleString()
		}

	  return num;
	} */

	checkOnlyNum ( val ) {
		if ( val !== '' && val.search(this.res) != -1 ) {
      alert('숫자만 입력가능합니다.');
      return false;
    }
    return true;
	}

	checkNum ( val ) {
		let num= parseInt(val.replace(/,/g,""));
		if( !this.checkOnlyNum(val) ) {
			val= val.replace(this.res,"");
			num= parseInt(val.replace(/,/g,""));
		}
		return num || '';
	}

	checkNumStr ( val ) {
		let num= val.replace(/,/g,"");
		if( !this.checkOnlyNum(val) ) {
			val= val.replace(this.res,"");
			num= val.replace(/,/g,"");
		}
		return num || '';
	}
}
